module.exports = __webpack_public_path__ + "static/1251719888.fed888a9.jpg";